import { IModalMethods, StoreModalProps } from "@/interfaces/Modal";
import { NoteForm } from "@/interfaces/Note";
import { useStoreInstructorNoteMutation } from "@/services/instructors/notes";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import {
  ElementRef,
  ForwardRefRenderFunction,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { SubmitHandler } from "react-hook-form";
import { ToastContentProps, toast } from "react-toastify";
import StoreNoteModal from "../StoreNoteModal";

const StoreInstructorNoteModal: ForwardRefRenderFunction<
  IModalMethods,
  Pick<StoreModalProps, "id">
> = ({ id }, ref) => {
  const StoreNoteModalRef = useRef<ElementRef<typeof StoreNoteModal>>(null);
  const [storeInstructorNoteAsync] = useStoreInstructorNoteMutation();

  const showOrHiddenModal = () =>
    StoreNoteModalRef.current?.showOrHiddenModal();

  useImperativeHandle(ref, () => ({
    showOrHiddenModal,
  }));

  const onSubmit: SubmitHandler<NoteForm> = async (data) => {
    toast.promise(storeInstructorNoteAsync([id, data]).unwrap(), {
      pending: "Ajout de la note en cours...",
      success: {
        render() {
          showOrHiddenModal();
          return (
            <p style={{ marginBottom: 0, textAlign: "center" }}>
              La note à bien été ajoutée 🤩
            </p>
          );
        },
      },
      error: {
        render({ data }: ToastContentProps<FetchBaseQueryError>) {
          if (data?.status === 422) {
            return "Les champs que vous avez remplis semblent être incorrects.";
          }
          return "Une erreur est survenue";
        },
      },
    });
  };

  return <StoreNoteModal ref={StoreNoteModalRef} onSubmit={onSubmit} />;
};

export default forwardRef(StoreInstructorNoteModal);
